/* eslint camelcase: 0 */
import { Company } from '@/infrastructure/network/Monitaro/schema/models'
import { ICompanyProps, EmptyCompanyPropsFactory } from '@/entities/Company'

export const toCompanyProps = (props: Company | null | undefined): ICompanyProps => {
  if (!props) {
    return EmptyCompanyPropsFactory()
  }

  const { id, price_id, industries, name, kana, users_count, properties, created_at, updated_at } = props

  return EmptyCompanyPropsFactory({
    id,
    priceId: price_id,
    industries,
    name,
    kana,
    usersCount: users_count,
    properties,
    createdAt: created_at,
    updatedAt: updated_at
  })
}
